const URL = {
  HEALTH: 'health',
  GET_CHATS: '{applicationId}/chat',
  SEND_CHAT_MESSAGE: 'chat',
  GET_CHAT_MESSAGES: '{applicationId}/chat/{chatId}',
  UPLOAD_CHAT_ATTACHMENT: '{applicationId}/chat/attachment',
  DELETE_CHAT_ATTACHMENT:
    '{applicationId}/chat/{chatId}/attachment/{attachmentId}',
  UPDATE_CHAT_MESSAGE: '{applicationId}/chat/{chatId}/outline',
  CHECK_ATTACHMENT_STATUS:
    '{applicationId}/chat/{chatId}/attachment/{attachmentId}/exists',
  FINAL_TOOL:
    '{applicationId}/chat/final-tool?courseId={courseId}&languageCode={languageCode}&chatId={chatId}&isMobile={isMobile}&courseCode={courseCode}',
  GET_TRANSLATED_CONTENT: 'content/translate',
}

export default URL
